<template>
  <v-container class="Validation no-padding full-container">
    <PageHeader
      class="px-8 px-md-16 pt-16"
      :topic="$t('subscription.topic')"
      :title="$t('subscription.page-title.Validation')"
      hideButtons
    />
    <ValidationTabs />

    <div class="Validation_content Validation_content--solid-background pa-8">
      <div>
        <v-checkbox
          v-model="validation"
          on-icon="done"
          off-icon=""
          hide-details
          :label="$t('subscription.certify-infos')"
          class="checkbox--green my-1 mr-2 button-purple ml-6"
          elevation="0"
        />
      </div>
    </div>

    <div class="ValidationTabs_content pa-8 d-flex justify-center">
      <v-btn
        text
        class="theme-btn app-button-secondary color-white nice-padding mr-6"
        @click="onClickLeftButton"
      >
        {{ $t('subscription.btn-back') }}
      </v-btn>

      <v-btn
        text
        class="theme-btn app-button-success color nice-padding"
        :disabled="!nextButtonIsEnabled"
        @click="onClickRightButton"
      >
        {{ $t('subscription.btn-next-end') }}
      </v-btn>
    </div>

    <ScrollUpButton />
  </v-container>
</template>

<script>
  import ScrollUpButton from '@/components/ui/partials/ScrollUpButton/ScrollUpButton'
  import PageHeader from '@/components/ui/partials/PageHeader/PageHeader'

  import CommonMixin from '@/mixins/store/CommonMixin'
  import ApiService from '@/services/ApiService'
  import ValidationTabs from './ValidationTabs.vue'

  export default {
    components: {
      ScrollUpButton,
      PageHeader,
      ValidationTabs,
    },
    mixins: [CommonMixin,],
    data() {
      return {
        validation: false,
      }
    },
    computed: {
      nextButtonIsEnabled() {
        return this.validation
      },
    },
    mounted() {
      if (this.customerFileCompletion !== 100) {
        this.$router.push({ name: 'Profile', })
      }
    },
    methods: {
      async onClickRightButton() {
        const result = await this.validateProfile()
        if (result) {
          this.$router.push({ name: 'Profile', })
        }
      },
      onClickLeftButton() {
        this.$router.push({ name: 'Profile', })
      },

      async validateProfile() {
        this.toggleAppLoader(true)
        const result = await ApiService.validatePersonFolder(this.currentUser.id)
        this.toggleAppLoader(false)
        if (result.errors) {
          this.$message({
            type: 'error',
            text: 'valid_infos_error',
          })

          return false
        } else {
          this.$message({
            type: 'success',
            text: 'valid_infos_success',
          })
          this.refreshMainProfile()

          return true
        }
      },
    },
  }
</script>

<style scoped lang="scss">
.Validation {
  &_content {
    max-width: 1060px;
    margin: 1rem auto;
    &--solid-background {
      background: white;
    }
  }
}
</style>
